/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdWebFeaturesAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptions, FxIdWebFeaturesAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptionsFromJSONTyped, FxIdWebFeaturesAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptionsToJSON, } from './FxIdWebFeaturesAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptions';
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTransferOptionsFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTransferOptionsFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTransferOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdWebFeaturesAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptions(json)) {
        return FxIdWebFeaturesAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTransferOptionsToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTransferOptionsToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTransferOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdWebFeaturesAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptions(value)) {
        return FxIdWebFeaturesAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTransferOptions.js.map